import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import {
  allTarifs, plateformes, getTaux, fmtRange
} from '../../data/tarifsData';
import './Tarifs.css';

export default function Tarifs() {
  const [devise, setDevise] = useState('FCFA');
  const [open,   setOpen]   = useState({});
  const { data }  = useApp();

  // ── Taux réels depuis Firebase/BCE ──────────────────────
  const TAUX = getTaux(data.tauxChange || {});

  function toggle(id) {
    setOpen(o => ({ ...o, [id]: !o[id] }));
  }

  function fmt1(fcfa) {
    if (devise === 'USD') return Math.round(fcfa / TAUX.USD).toLocaleString('fr-FR') + ' $';
    if (devise === 'EUR') return Math.round(fcfa / TAUX.EUR).toLocaleString('fr-FR') + ' €';
    return fcfa.toLocaleString('fr-FR') + ' FCFA';
  }

  function fmtR(min, max) {
    return fmtRange(min, max, devise, TAUX);
  }

  return (
    <section className="tarifs-section" id="tarifs">
      <div className="tarifs-header">
        <div className="tarifs-tag">💰 TARIFS & ABONNEMENTS</div>
        <h2 className="tarifs-title">Nos Offres</h2>
        <p className="tarifs-sub">Transparence totale — tous nos prix en FCFA, USD et EUR</p>

        {/* Sélecteur devise */}
        <div className="tarifs-devise">
          {['FCFA','USD','EUR'].map(d => (
            <button
              key={d}
              className={`tarifs-devise-btn ${devise === d ? 'active' : ''}`}
              onClick={() => setDevise(d)}
            >
              {d}
            </button>
          ))}
        </div>

        {/* Bandeau taux en temps réel */}
        <div style={{
          fontSize:'11px', color: TAUX.auto ? '#00CC88' : 'var(--muted)',
          marginTop:'8px', display:'flex', alignItems:'center',
          justifyContent:'center', gap:'6px'
        }}>
          {TAUX.auto ? '🟢' : '⚙️'}
          {TAUX.auto
            ? `Taux BCE automatiques · 1€ = ${TAUX.EUR} FCFA · 1$ = ${TAUX.USD} FCFA${TAUX.lastUpdate ? ' · ' + TAUX.lastUpdate : ''}`
            : `Taux indicatifs · 1€ ≈ ${TAUX.EUR} FCFA · 1$ ≈ ${TAUX.USD} FCFA`
          }
        </div>
      </div>

      {/* Plateformes */}
      {plateformes && plateformes.length > 0 && (
        <div className="tarifs-plateformes">
          <h3 className="tarifs-section-title">🖥️ Plateformes disponibles</h3>
          <div className="tarifs-plat-grid">
            {plateformes.map(p => (
              <div key={p.id} className="tarifs-plat-card">
                <div className="tarifs-plat-icon">{p.icon}</div>
                <div className="tarifs-plat-name">{p.name}</div>
                <div className="tarifs-plat-desc">{p.desc}</div>
                {/* Garde anti-"0" : prixFcfa doit être un nombre STRICTEMENT positif */}
                {p.prixFcfa > 0 && (
                  <div className="tarifs-plat-prix">
                    {fmt1(p.prixFcfa)}
                    {p.unit && <span className="tarifs-plat-unit">/{p.unit}</span>}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Tous les tarifs */}
      {allTarifs.map(section => (
        <div key={section.id} className="tarifs-bloc">
          <div
            className="tarifs-bloc-head"
            onClick={() => toggle(section.id)}
            style={{ cursor:'pointer' }}
          >
            <div className="tarifs-bloc-title">
              <span>{section.icon}</span>
              <span>{section.title}</span>
            </div>
            <span className="tarifs-bloc-toggle">
              {open[section.id] ? '▲' : '▼'}
            </span>
          </div>

          {open[section.id] && (
            <div className="tarifs-bloc-body">
              {section.subtitle && (
                <p className="tarifs-bloc-sub">{section.subtitle}</p>
              )}

              {/* Plans */}
              {section.plans && (
                <div className="tarifs-plans">
                  {section.plans.map((plan, i) => (
                    <div
                      key={i}
                      className={`tarifs-plan ${plan.highlight ? 'highlight' : ''}`}
                      style={{ '--plan-color': plan.color || 'var(--primary)' }}
                    >
                      {plan.badge && (
                        <div className="tarifs-plan-badge"
                          style={{ background: plan.color || 'var(--primary)' }}>
                          {plan.badge}
                        </div>
                      )}
                      <div className="tarifs-plan-name"
                        style={{ color: plan.color || 'var(--primary)' }}>
                        {plan.name}
                      </div>
                      <div className="tarifs-plan-prix">
                        {plan.minFcfa && plan.maxFcfa
                          ? fmtR(plan.minFcfa, plan.maxFcfa)
                          : plan.fcfa > 0 ? fmt1(plan.fcfa) : 'Sur devis'
                        }
                      </div>
                      {plan.unit && (
                        <div className="tarifs-plan-unit">/{plan.unit}</div>
                      )}
                      {plan.maintenance && (
                        <div className="tarifs-plan-maintenance">
                          🔧 Maintenance : {fmt1(plan.maintenance.fcfa)}/mois
                        </div>
                      )}
                      {plan.description && (
                        <div className="tarifs-plan-desc">{plan.description}</div>
                      )}
                      {plan.inclus && (
                        <ul className="tarifs-plan-inclus">
                          {plan.inclus.map((item, j) => (
                            <li key={j}>
                              <span style={{ color: plan.color || 'var(--primary)' }}>✓</span>
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Modules à la carte */}
              {section.modules && (
                <div className="tarifs-modules">
                  <h4>Modules à la carte</h4>
                  <div className="tarifs-modules-grid">
                    {section.modules.map((m, i) => (
                      <div key={i} className="tarifs-module">
                        <div className="tarifs-module-name">{m.name}</div>
                        <div className="tarifs-module-prix">
                          {m.minFcfa && m.maxFcfa
                            ? fmtR(m.minFcfa, m.maxFcfa)
                            : m.fcfa > 0 ? fmt1(m.fcfa) : 'Sur devis'
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Forfaits */}
              {section.forfaits && (
                <div className="tarifs-forfaits">
                  <h4>Forfaits complets</h4>
                  <div className="tarifs-plans">
                    {section.forfaits.map((f, i) => (
                      <div key={i} className="tarifs-plan">
                        <div className="tarifs-plan-name">{f.name}</div>
                        <div className="tarifs-plan-prix">
                          {f.minFcfa && f.maxFcfa
                            ? fmtR(f.minFcfa, f.maxFcfa)
                            : f.fcfa > 0 ? fmt1(f.fcfa) : 'Sur devis'
                          }
                        </div>
                        {f.unit && (
                          <div className="tarifs-plan-unit">/{f.unit}</div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Lignes simples */}
              {section.lignes && (
                <div className="tarifs-lignes">
                  {section.lignes.map((l, i) => (
                    <div key={i} className="tarifs-ligne">
                      <span className="tarifs-ligne-name">{l.name}</span>
                      <span className="tarifs-ligne-prix">
                        {l.minFcfa && l.maxFcfa
                          ? fmtR(l.minFcfa, l.maxFcfa)
                          : l.fcfa > 0 ? fmt1(l.fcfa) : 'Sur devis'
                        }
                        {l.unit && <span className="tarifs-ligne-unit">/{l.unit}</span>}
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {section.note && (
                <div className="tarifs-note">💡 {section.note}</div>
              )}
            </div>
          )}
        </div>
      ))}

      {/* Note bas */}
      <div className="tarifs-bottom-note">
        <p>
          💡 Tous les prix sont indicatifs et peuvent varier selon la complexité du projet.
          Contactez-nous pour un devis personnalisé gratuit.
        </p>
        <p style={{ fontSize:'11px', color:'var(--muted)', marginTop:'6px' }}>
          {TAUX.auto
            ? `Taux de change mis à jour automatiquement via la BCE${TAUX.lastUpdate ? ' · ' + TAUX.lastUpdate : ''}`
            : 'Taux de change indicatifs — peuvent varier selon les marchés'
          }
        </p>
      </div>
    </section>
  );
}